import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'bxl-gait-analysis-walking-shared',
  templateUrl: 'gait-analysis-walking-shared.component.html',
  styleUrls: ['gait-analysis-walking-shared.component.scss']
})
export class GaitAnalysisWalkingSharedComponent implements OnInit {
  initialized = false;


  constructor() { }

  ngOnInit(): void {
    this.initialized = true;
  }

}
